import React, { Component } from 'react';
import ConstCommon from '../../common/Const';
import { getCodeFromQuery, removeDragCode } from '../../helpers/Common';
import Chart from './Chart';
import { changeCode, subscribeRealtimeTick } from './reducer';
import Notifications from './Notifications';
import FADividendTab from './FADividendTab';
import { connect } from 'react-redux';
import GroupButton from './../common/header/group-button';
import ScoreBox from './ScoreBox';
import './FADividendAnalysis.scss';
import Search from './search/Search';
import ScrollComponent from './../../common/ScrollComponent';
import { Provider } from './../../common/ComponentIdContext';
import { ComponentNameProvider } from './../../common/ComponentNameContext';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';
import { REDUCER_NAME } from './reducer';

class FADividendAnalysis extends Component {
  constructor(props) {
    super(props);
    removeDragCode(this.props.glContainer);
    const { changeCode, id } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      changeCode(codeFromQuery, id);
    }
  }

  componentDidMount() {
    MessageHub.subscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
  }

  dispatchDataRealtimeTick = data => {
    const { subscribeRealtimeTick, id } = this.props;
    subscribeRealtimeTick(data, id);
  };

  componentWillUnmount() {
    MessageHub.unsubscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
  }

  render() {
    const { id, ticker } = this.props;
    return (
      <PreRender {...this.props}>
        <ComponentNameProvider
          value={ConstCommon.listComponent.FADividendAnalysis}
        >
          <Provider value={id}>
            <ScrollComponent>
              <div className="dividend-analysis-wrapper pt-8 px-20 d-flex flex-column h-100">
                <div className="da-top-content flex-shrink-0">
                  <Search />
                  <ScoreBox />
                  <GroupButton code={ticker} />
                  <Notifications id={id} />
                </div>
                <FADividendTab />
                <div className="cast-chart mt-20 flex-shrink-0">
                  <Chart />
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapDispatchToProps = {
  subscribeRealtimeTick,
  changeCode,
};

const mapStateToProps = (state, { id }) => ({
  ticker:
    state[REDUCER_NAME].listMultiComponent[id].condition.currentSearch
      .displayCode,
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FADividendAnalysis);
